import React from 'react';
import { Route, Switch } from 'react-router';

import routes from '../helpers/ApplicationRoutes';

import BucketMembersPage from './BucketMembersPage';
import BucketAssetsPage from './BucketAssetsPage';

const BucketPage = ({ location }) => (
    <React.Fragment>
        <Switch location={location}>
            <Route
                exact
                path={routes.bucketMembers.path}
                component={BucketMembersPage}
            />
            <Route
                exact
                path={routes.bucket.path}
                component={BucketAssetsPage}
            />
            <Route
                exact
                path={routes.bucketAssets.path}
                component={BucketAssetsPage}
            />
        </Switch>
    </React.Fragment>
);

export default BucketPage;



// WEBPACK FOOTER //
// ./src/pages/BucketPage.js